const thesis = {
  state: {
    unReadNum: ''
  },
  mutations: {
    updateUnReadNum (state, val) {
      state.unReadNum = val
    }
  }
}

export default thesis
